import { Injectable, signal } from '@angular/core';
import type { DegradedPlanStatus } from '@utils/lib/plan-access';

// The list of degraded statuses lives in `classifyPlanAccess`; re-exported
// here so existing importers keep working.
export type { DegradedPlanStatus };

/**
 * Shared service used by planActiveGuard to communicate a "degraded but
 * allowed" plan status to the layout banner.  Cancelled / suspended statuses
 * are never stored here — those do a hard redirect via the guard.
 */
@Injectable({ providedIn: 'root' })
export class PlanAlertService {
  readonly degradedStatus = signal<DegradedPlanStatus | null>(null);

  set(status: DegradedPlanStatus): void {
    this.degradedStatus.set(status);
  }

  clear(): void {
    this.degradedStatus.set(null);
  }
}
